// localStorage / sessionStorage, or null where the browser blocks them (private
// windows, locked-down profiles). Callers treat null as "not remembered".
// Kept apart from the pure libraries so those stay free of browser types.

export function sessionStore(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function localStore(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}
